import { DeleteCompaniesModal } from "@/frontend/features/Company/ui/DeleteCompanies/DeleteCompaniesModal/DeleteCompaniesModal";
import { TrashIcon } from "@/frontend/shared/assets/icons";
import { NormalButton } from "@/frontend/shared/ui/Button";
import styles from "./DeleteCompanies.module.scss";
import { deleteCompanies } from "../../model/deleteCompanies";
import { useState } from "react";
import { snackbarConstructor } from "@/frontend/shared/ui/CustomNotifications/ui/Snackbar/snackbarConstructor";
import { useScreenWidth } from "@/frontend/shared/lib/hooks/useScreenWidth";
import { SquareNormalButton } from "@/frontend/shared/ui/Button/SquareNormalButton/SquareNormalButton";

type TDeleteCompanyProps = {
  isSelected: boolean;
  ids: number[];
  triggerRefetch: () => void;
  isDisabled?: boolean;
};

export function DeleteCompanies({ isSelected, ids, triggerRefetch, isDisabled }: TDeleteCompanyProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  async function deleteCompaniesOnClick() {
    setIsDeleting(true);
    await deleteCompanies(ids)
      .then(() => {
        triggerRefetch();
        snackbarConstructor(`Successfully deleted ${ids.length} companies`, "normal");
      })
      .finally(() => {
        setIsDeleting(false);
      })
      .catch((error) => {
        snackbarConstructor("Error deleting companies", "error");
        console.error("Error:", error);
      });
  }

  const isMobile = useScreenWidth() <= 768;

  return (
    <DeleteCompaniesModal
      onClick={deleteCompaniesOnClick}
      isOpen={isOpen}
      onChange={isDisabled ? () => {} : setIsOpen}
      onClose={() => setIsOpen(false)}
      isDeleting={isDeleting}
    >
      <SquareNormalButton size="large" className={styles.btn} isDisabled={isSelected} variant="secondary">
        <TrashIcon />
        {!isMobile && "Remove"}
      </SquareNormalButton>
    </DeleteCompaniesModal>
  );
}
